import React from 'react';
import { FaChevronRight } from 'react-icons/fa';

function ListItemNavigateHint({ visible = true }) {
  if (!visible) {
    return null;
  }

  return (
    <span className="platform-content-list-item-chevron" aria-hidden="true">
      <FaChevronRight />
    </span>
  );
}

export default ListItemNavigateHint;
